/* @flow */
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';

function extractStatusCodesFromError(error): ?string {
  if (error.networkError && error.networkError.status >= 400) {
    return error.networkError.status.toString();
  } else {
    return null;
  }
}

type Options = {
  status: { [string]: Function },
};

/* The network error link is responsible for surfacing any
 * network errors between the browser and the apollo server
 * 
 * const networkErrorLink = NetworkErrorLink({
 *   status: {
 *     '401': ()     => {},
 *     '403': ()     => {},
 *     '404': ()     => {},
 *     '503': ()     => {},
 *     '*':   (code) => {},
 *   },
 * });
 *
 * options.status is a map of string <=> function because flow
 * doesn not support numbers as object key value yet.
 */
class NetworkErrorLink extends ApolloLink {
  constructor(options: Options) {
    super();
    this.options = options;
    this.link = onError(this.handler);
  }

  handler = (error: *) => {
    const code = extractStatusCodesFromError(error);

    if (!code) {
      return;
    }

    if (this.options.status[code]) {
      this.options.status[code]();
    } else if (this.options.status['*']) {
      this.options.status['*'](code);
    }
  };

  request(operation: *, forward: *) {
    return this.link.request(operation, forward);
  }
}

export { NetworkErrorLink };
